<script lang="ts">
	import { afterNavigate } from '$app/navigation'
	import { page } from '$app/state'
	import { storeHeroMenu } from '$lib/js/stores'
	import type { Category } from '$lib/js/elasticsearch/types'
	import type { Universe } from '$lib/js/strapi/types'
	import { getContextScope } from '$lib/js/helpers/i18n'

	interface Props {
		secondLevel: Category[];
		thirdLevel: Category[];
	}

	let { secondLevel, thirdLevel }: Props = $props();

	const universes = page.data.universes_menu.universes,
		scope = getContextScope()

	let firstActive = $state(parseInt(universes[0].cat_id))
	let secondActive = $state(secondLevel[0].id)

	let current = $state(firstActive)
	let current2 = $state(-1)
	let displayThird = $state('not-visible');
	

	function optionFirstHovered(option: Universe) {
		color = option.color
		firstActive = parseInt(option.cat_id)
		current = parseInt(option.cat_id)
		current2 = -1
		displayThird = 'not-visible'
	}

	function optionSecondHovered(option_id: number) {
		secondActive = option_id
		current2 = option_id
		displayThird = 'visible'
	}

	let color = $state(universes[0].color)

	function closeMenu() {
		$storeHeroMenu = ''
	}

	afterNavigate(() => {
		$storeHeroMenu = ''
	})
</script>


<div class="universes-menu__inner" style="--univ-sec: {color}">
	<div class="universes-menu__primary">
		{#each universes as option}
			<a
				role="menuitem"
				style="background: {option.color};"
				class="item"
				class:selected={current === parseInt(option.cat_id)}
				href="/{scope}/u/{option.name}"
				onmouseenter={() => optionFirstHovered(option)}
				onclick={() => closeMenu()}
			>
				<div class="item__header">
					{#if current === parseInt(option.cat_id)}
						<img
							class="logo"
							src="/images/universes/logos/{option.name}.svg"
							alt="Bixoto {option.name}"
							title="Bixoto {option.name}"
						/>
					{:else}
						<img
							class="title"
							src="/images/universes/titles/{option.name}_title.png"
							alt="Bixoto {option.name}"
							title="Bixoto {option.name}"
						/>
					{/if}
					<img
						src="/images/universes/main/main_{option.name}.png"
						alt="Bixoto {option.name}"
						title="Bixoto {option.name}"
					/>
				</div>

				<p class="item__desc" style="color: {option.color_sec}">{option.description}</p>
			</a>
		{/each}
	</div>

	<div class="universes-menu__secondary" style="background: var(--univ-sec)">
		{#each secondLevel as option}
			{#if option.parent_id === firstActive}
				<a
					role="menuitem"
					class:selected={current2 === option.id}
					href="/{scope}/{(option.url_path)}"
					onmouseenter={() => optionSecondHovered(option.id)}
					onclick={() => closeMenu()}
				>{option.name}</a>
			{/if}
		{/each}
	</div>

	<div class="universes-menu__tertiary {displayThird}">
		{#each thirdLevel as option}
			{#if option.parent_id === secondActive}
				<a role="menuitem" href="/{scope}/{option.url_path}" onclick={() => closeMenu()}>{option.name}</a>
			{/if}
		{/each}
	</div>
</div>


<style lang="scss">
  .item {
    margin-bottom: 5px;
    margin-right: 10px;

    &:last-child {
      margin-bottom: 0;
    }

    &:not(.selected) {
      padding: 0 15px;
      background: var(--grey) !important;

      img.logo {
        transform: scale(0.7);
        // filter: grayscale(70%);
      }

      .item__header {
        align-items: center;
        margin-top: 0;
      }
    }

    &__header {
      display: flex;
      justify-content: space-between;
      align-items: flex-end;
      margin-top: -20px;

      img.title {
        height: 24px;
        object-fit: contain;
        width: auto;
        margin-bottom: 5px;
      }

      img.logo {
        width: 70px;
      }

      img {
        transition: all linear 1s;
        width: 70px;
      }
    }

    &__desc {
      display: none;
      font-size: 12px;
      margin-top: 10px;
      margin-bottom: 5px;
    }

    &.selected {
      padding: 15px 15px 8px;

      .item {
        &__desc {
          display: block;
        }
      }
    }
  }

  .universes-menu {
    &__inner {
      max-height: calc(100dvh - 210px);
      display: flex;
      transition: all linear 0.25s;
      overflow: visible;
    }

    &__primary,
    &__secondary,
    &__tertiary {
      display: flex;
      flex-direction: column;
      width: 100%;
      max-width: 250px;
      overflow-y: scroll;
      margin-top: 30px;

      a {
        color: black;
        padding: 8px 15px;

        &:hover {
          color: var(--main);
        }

        &.selected {
          background: var(--main);
          color: white;
        }
      }
    }

    &__primary {
      margin-top: 0;
      padding-top: 30px;
    }

    &__secondary {
      background: var(--grey);
    }

    &__tertiary {
      transition: all linear 0.125s;
      max-width: 100%;
      flex-wrap: wrap;
      flex-direction: row;
      justify-content: flex-start;
      height: 100%;
      overflow-y: scroll;
      max-height: calc(100vh - 300px);

      @media (min-width: 1330px) {
        overflow-y: hidden;
      }

      @media (min-width: 1330px) and (max-width: 1595px) {
        max-height: calc(100vh - 190px);
      }

      &.not-visible {
        visibility: hidden;
        opacity: 0;
      }

      &.visible {
        visibility: visible;
        opacity: 1;
      }

      a {
        padding: 5px 15px;
        width: 250px;
      }
    }
  }
</style>
